<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        <sidebar-item :link="{name: 'Página Principal', icon: 'now-ui-icons design_app', path: '/dashboard'}"></sidebar-item>
        <sidebar-item v-if="!accessLevel" :link="{name: 'Monitor', icon: 'now-ui-icons location_world', path: '/monitor'}"></sidebar-item>
        <sidebar-item v-if="!accessLevel" :link="{name: 'Monitor de Certificado', icon: 'now-ui-icons location_world', path: '/vencimentoCertificado'}"></sidebar-item>
        <sidebar-item v-if="!accessLevel" :link="{name: 'Usuários', icon: 'now-ui-icons users_single-02', path: '/usuarios'}"></sidebar-item>
        <sidebar-item v-if="!accessLevel" :link="{name: 'Grupos', icon: 'now-ui-icons users_single-02', path: '/grupos'}"></sidebar-item>
        <sidebar-item v-if="!accessLevel" :link="{name: 'Instalações', icon: 'now-ui-icons users_single-02', path: '/instalacoes'}"></sidebar-item>
        <sidebar-item v-if="!accessLevel" :link="{name: 'Fiscal', icon: 'now-ui-icons users_single-02', path: '/monitor-fiscal'}"></sidebar-item>
        <sidebar-item v-if="!accessLevel" :link="{name: 'Criação de Tokens', icon: 'now-ui-icons arrows-1_cloud-upload-94'}">
          <sidebar-item :link="{name: 'Desktop', path: '/criaTokenDesk'}"></sidebar-item>
          <sidebar-item :link="{name: 'APP', path: '/criaTokenApp'}"></sidebar-item>
          <sidebar-item :link="{name: 'Planilha Pizza', path: '/planilha-pizza'}"></sidebar-item>
          <sidebar-item :link="{name: 'Novo Emissor', path: '/criaTokenEmissor'}"></sidebar-item>
          <sidebar-item v-if="temPermissaoSubirPlanilha" :link="{name: 'Subir Planilha de Produtos', path: '/subirPlanilha'}"></sidebar-item>
          <sidebar-item v-if="temPermissaoSubirPlanilha" :link="{name: 'Subir Planilha de Clientes', path: '/subirPlanilhaClientes'}"></sidebar-item>
          <sidebar-item v-if="temPermissaoAtualizarPlanilha" :link="{name: 'Atualizar Produtos por Planilha', path: '/atualizarPlanilha'}"></sidebar-item>
          <sidebar-item v-if="temPermissaoCopiarCardapio" :link="{name: 'Copiar Cardápio PDV', path: '/CopiarCardapio'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Sugestão de Imagens', icon: 'now-ui-icons objects_spaceship', path: '/suggestions'}"></sidebar-item>
        <sidebar-item :link="{name: 'Campanhas', icon: 'now-ui-icons objects_spaceship', path: '/notifications-list'}"></sidebar-item>
        <!-- <sidebar-item :link="{name: 'Novo Contrato', icon: 'now-ui-icons objects_spaceship', path: '/contratacao-planos'}"></sidebar-item> -->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <router-view name="header"></router-view>

      <div :class="{content: !$route.meta.hideContent}" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>


</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar'
  import 'perfect-scrollbar/css/perfect-scrollbar.css'

  function hasElement (className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar (className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import {SlideYDownTransition, ZoomCenterTransition} from 'vue2-transitions'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      SlideYDownTransition,
      ZoomCenterTransition
    },
    data() {
      return {
        user: null,
        accessLevel: null,
        temPermissaoSubirPlanilha: false,
        temPermissaoAtualizarPlanilha: false,
        temPermissaoCopiarCardapio: false,
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    },
    mounted () {
      this.accessLevel = window.accessLevel;
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on')
      } else {
        docClasses.add('perfect-scrollbar-off')
      }

      let rawUser = localStorage.getItem('user_admin');
      console.log
      try {
        if(rawUser) {
          this.user = JSON.parse(rawUser)
            
          // Check de Permissões
          let usuariosSubirPlanilha = [531,7,1540,2189,2190,3465,3551,15,3751,2834,4082,430,4182,4022,3665,4087,4695,570,4728,4085,3541,4789, 4911,5142,5179,5775,5958,5965,2779,6312]
          let usuariosAtualizarPlanilha = [531,7,1540,2189,2190,3465,3551,15,3751,2834,4082,430,4182,4022,3665,4087,4695,570,4728,4085,3541,4789, 4911,5142,5179,5775,4974,5958,5965,5458,2779,6312]
          let usuariosCopiarCardapio = [531,7,1540,2189,4182,3751,3541,4728,4789,3665,5775,4085,4022,5958,5965,5179,2779,6312]

          this.temPermissaoSubirPlanilha = usuariosSubirPlanilha.includes(this.user.id)
          this.temPermissaoAtualizarPlanilha = usuariosAtualizarPlanilha.includes(this.user.id)
          this.temPermissaoCopiarCardapio = usuariosCopiarCardapio.includes(this.user.id)
        }
      } catch(e) {
        console.error(e)
      }
    }
  }
</script>
<style lang="scss">
  $scaleSize: .95;
  @keyframes zoomIn95 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
      opacity: 1;
    }
  }
  .main-panel .zoomIn {
    animation-name: zoomIn95;
  }
  @keyframes zoomOut95 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }
  .main-panel .zoomOut {
    animation-name: zoomOut95;
  }
</style>
